module.exports = __webpack_public_path__ + "static/media/comment-plus.e3f0aee7.svg";